import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { AccountingService } from '../../accounting/accounting.service';
import { getRange, Range } from '../dashboard/dashboard.util';
import { LoadDashboard, LoadSummary, LoadTransactions, UpdateFilter } from './home.actions';


export class HomeStateModel {
  filter?: Range
  transactions: any[] = []
  summary?: any
}

const defaults: HomeStateModel = {
  transactions: [],
  filter: getRange('90-days')
};

@State<HomeStateModel>({
  name: 'home',
  defaults
})
@Injectable()
export class HomeState {

  constructor(
    private accounting: AccountingService,
  ) { }

  @Action(UpdateFilter)
  updateFilter({ patchState }: StateContext<HomeStateModel>, { from, to }: UpdateFilter) {

    patchState({ filter: { from, to } });
  }

  @Action(LoadDashboard)
  loadDashboard({ dispatch }: StateContext<HomeStateModel>, { from, to }: LoadDashboard) {

    return dispatch([
      new LoadTransactions(from, to),
      new LoadSummary(from, to),
    ])
  }

  @Action(LoadTransactions)
  loadTransactions({ patchState }: StateContext<HomeStateModel>, { from, to }: LoadTransactions) {

    return this.accounting.getAllTransactions(from, to).pipe(
      tap((transactions: any) => {
        patchState({ transactions })
      })
    )
  }

  @Action(LoadSummary)
  loadSummary({ patchState }: StateContext<HomeStateModel>, { from, to }: LoadSummary) {
    return this.accounting.getSummary(from, to).pipe(
      tap((summary: any) => {
        patchState({ summary })
      })
    )
  }


  @Selector()
  static transactions(state: HomeStateModel) {
    return state.transactions;
  }

  @Selector()
  static summary(state: HomeStateModel) {
    return state.summary;
  }

  @Selector()
  static filter(state: HomeStateModel) {
    return state.filter;
  }
}
